import { render, staticRenderFns } from "./MenuBarBulletedListButton.vue?vue&type=template&id=8511f74c"
import script from "./MenuBarBulletedListButton.vue?vue&type=script&lang=js"
export * from "./MenuBarBulletedListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports